import Axios from "axios";

const dotenv = require("dotenv");
dotenv.config();

async function main(documents) {
  const URL = "https://eastern-surface-293816.el.r.appspot.com/api/nlp";

  const { data, status } = await Axios.post(URL, { data: documents });

  if (status === 200) {
    return data;
  }
  return "";
}

export default main;
